angular.module('signalview.TOOLTIPS', []);
